import {
  type Cue,
  type CueSegmentationConfig,
  DEFAULT_SEGMENTATION_CONFIG,
  oneWordPerCue,
  resegmentCues,
} from "subtitletools";

export type SegmentationMode = "original" | "one-word" | "custom";

export const SEGMENTATION_HISTORY_KEY = "segmentation";

export function defaultSegmentationRules(): CueSegmentationConfig {
  return {
    ...DEFAULT_SEGMENTATION_CONFIG,
    stopCharacters: [...DEFAULT_SEGMENTATION_CONFIG.stopCharacters],
  };
}

export function sourceHasWordTimings(cues: Cue[]): boolean {
  return cues.some((cue) => (cue.words?.length ?? 0) > 0);
}

export function segmentOriginalCues({
  originalCues,
  mode,
  rules,
  createId,
}: {
  originalCues: Cue[];
  mode: SegmentationMode;
  rules: CueSegmentationConfig;
  createId: () => string;
}): Cue[] {
  if (mode === "original") return originalCues;
  if (mode === "one-word") return oneWordPerCue(originalCues, { createId });
  return resegmentCues(originalCues, rules, { createId });
}
